import { themeGet } from '@styled-system/theme-get';
import React, { memo } from 'react';
import styled from 'styled-components';
import { Button, Flex, getPaletteColor } from 'pcln-design-system';
import FooterHint from '../FooterHint/FooterHint';
const FooterFlex = /*#__PURE__*/styled(Flex).withConfig({
  displayName: "Footer__FooterFlex",
  componentId: "sc-2aaigk-0"
})(["&&&{background:", ";", " ", "{box-shadow:none;height:auto;}z-index:1000;}"], getPaletteColor('background.lightest'), props => !props.use2024DesignSeti && `
      border-top: 1px solid ${getPaletteColor('border.base')(props)};
    `, themeGet('mediaQueries.md'));
function Footer({
  dismissCalendar,
  roundedCorners,
  use2024DesignSeti
}) {
  return React.createElement(FooterFlex, {
    borderRadius: roundedCorners ? '2xl' : undefined,
    rounded: roundedCorners ? 'bottom' : undefined,
    p: use2024DesignSeti ? 3 : 2,
    pt: use2024DesignSeti ? 0 : undefined,
    width: 1,
    justifyContent: 'space-between',
    alignItems: 'center',
    use2024DesignSeti: use2024DesignSeti
  }, React.createElement(FooterHint, null), React.createElement(Button, {
    "aria-label": 'Dismiss calendar',
    size: use2024DesignSeti ? 'medium' : 'small',
    variation: use2024DesignSeti ? 'fill' : 'plain',
    onClick: dismissCalendar
  }, "Done"));
}
export default memo(Footer);